import PropTypes from 'prop-types'
import { ArrowRight, Activity, Brain, Compass } from 'lucide-react'

function UnlockPanel({ onStart }) {
  return (
    <section className="unlock" aria-labelledby="unlock-h">
      <div className="section__head">
        <h2 id="unlock-h">17 more questions complete the picture</h2>
        <p className="section__desc">The rest of the DASS-21, plus three lifestyle questions. About three minutes. It adds:</p>
      </div>
      <ul className="unlock__list">
        <li><Activity size={16} strokeWidth={2} /><span>Life impact across five domains</span></li>
        <li><Brain size={16} strokeWidth={2} /><span>Your full depression, anxiety and stress profile</span></li>
        <li><Compass size={16} strokeWidth={2} /><span>Behavioural profile and readiness to change</span></li>
      </ul>
      <div className="unlock__cta">
        <button type="button" className="btn" onClick={onStart}>
          Continue the assessment
          <ArrowRight size={18} strokeWidth={2.25} />
        </button>
      </div>
    </section>
  )
}

UnlockPanel.propTypes = {
  onStart: PropTypes.func.isRequired,
}

export default UnlockPanel
